module.exports = __webpack_public_path__ + "static/media/NO_LIVESTOCK.98a8e93c.svg";